function BtnPrimary({ text, icon, href }) {
  return (
    <a className="btn-primary" href={href}>
      <span>{text}</span>
      {icon && <span className="btn-icon">{icon}</span>}
    </a>
  );
}

export default BtnPrimary;
